import React from "react";
import SearchIcon from "assets/images/search.svg";
import styles from "../../Notes.module.scss";

const SearchBar = ({
  handleSearchTerm,
  searchValue,
  isModal,
  placeholder,
  inputRef,
  parentClass = "",
}) => {
  return (
    <div
      className={
        `${isModal ? styles.modal_search_bar : styles.new_search_bar}` +
        parentClass
      }
      data-type="search"
    >
      <span className={styles.search_icon}>
        <img src={SearchIcon} alt="search icon" />
      </span>
      <input
        ref={inputRef}
        type="text"
        className={styles.search_input}
        placeholder={placeholder}
        onChange={handleSearchTerm}
        value={searchValue}
      />
    </div>
  );
};

export default SearchBar;
